import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automatic billing',
  buttons: {
    add_subscription: 'Add subscription',
    suspend_company: 'Suspend restaurant',
    restore_company: 'Restore restaurant',
    edit_suspend: 'Edit suspend info',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  modals: {
    suspend_company: {
      title: 'Are you sure to suspend {{company}}?',
      description:
        'This will cancel all active subscriptions, disable live orders, and notify the restaurant owner via email regarding cancellation. Please select a reason before confirming.',
      suspense_reason: {
        label: 'Select reason for suspension',
        placeholder: 'Choose a reason',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Closed or Ownership Change',
          [SUSPENSE_REASON.LowRoi]: 'Low ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Pricing/Fees Sensitivity',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Missing Integrations/Product Gaps',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Poor Onboarding/Activation',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Support Dissatisfaction',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Switched to Competitor/Marketplace/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Marketing Performance Disappointment',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Falsche Registrierung / Daten',
        },
        validation: {
          required: 'Please choose a reason',
        },
      },
      suspense_competitor: {
        label: 'Which competitor did they switch to?',
        placeholder: 'Please choose a competitor',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Other',
        },
        validation: {
          required: 'Please choose a competitor',
        },
      },
      suspense_reason_notes: {
        label: 'Additional context (optional)',
        placeholder: 'Provide any additional details',
      },
    },
    restore_company: {
      title: 'Are you sure to restore {{company}}?',
      description: 'You will still have to create subscription and enable live orders manually.',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load subscription details',
    failed_to_suspend_company: 'Failed to suspend restaurant. Please contact tech support',
    failed_to_restore_company: 'Failed to restore restaurant. Please contact tech support',
  },
};
